import { TwitterFollowButton, TwitterHashtagButton, TwitterMentionButton, TwitterTweetEmbed } from "react-twitter-embed";
import TextLoop from "react-text-loop";
import { Emojione } from "react-emoji-render";
import Warning from "../../../../src/components/Presentations/Warning";
import Success from "../../../../src/components/Presentations/Success";
import CodeBlock from "../../../../src/components/Presentations/CodeBlock";
import AnimatedBackground from "../../../../src/components/Presentations/AnimatedBackground";
import Confetti from "../../../../src/components/Presentations/Confetti";
import QandA from "../../../../src/components/Presentations/QandA";
import HTMLEditor from "../../../../src/components/HTMLEditor/HTMLEditorSimple";
import Poll from "../../../../src/components/Presentations/Poll";
import TitleSlide from "../../../../src/components/Presentations/Layout/TitleSlide";
import BaseSlide from "../../../../src/components/Presentations/Layout/BaseSlide";
import ListWithImage from "../../../../src/components/Presentations/Layout/ListWithImage";
import Infobox from "../../../../src/components/Presentations/Refactored/Infobox";
import Bootstrap from "../../../../MDX/Decks/FTW-PRECOURSE-4/img/bootstrap.jpg";
import MobileTraffic from "../../../../MDX/Decks/FTW-PRECOURSE-4/img/mobile-traffic.jpg";
import GridExample from "../../../../MDX/Decks/FTW-PRECOURSE-4/img/grid-example.png";
import BootstrapGrid from "../../../../MDX/Decks/FTW-PRECOURSE-4/img/bootstrap-grid.jpg";
import BootstrapBreakpoints from "../../../../MDX/Decks/FTW-PRECOURSE-4/img/bootstrap-breakpoints.png";
import LightSwitch from "../../../../MDX/Decks/FTW-PRECOURSE-4/img/light-switch.jpg";
import Boxes from "../../../../MDX/Decks/FTW-PRECOURSE-4/img/boxes.png";
import DarkRoom from "../../../../MDX/Decks/FTW-PRECOURSE-4/img/dark.jpg";
import Array from "../../../../MDX/Decks/FTW-PRECOURSE-4/img/array1.gif";
import Array2 from "../../../../MDX/Decks/FTW-PRECOURSE-4/img/array3.png";
import * as React from 'react';
export default {
  TwitterFollowButton,
  TwitterHashtagButton,
  TwitterMentionButton,
  TwitterTweetEmbed,
  TextLoop,
  Emojione,
  Warning,
  Success,
  CodeBlock,
  AnimatedBackground,
  Confetti,
  QandA,
  HTMLEditor,
  Poll,
  TitleSlide,
  BaseSlide,
  ListWithImage,
  Infobox,
  Bootstrap,
  MobileTraffic,
  GridExample,
  BootstrapGrid,
  BootstrapBreakpoints,
  LightSwitch,
  Boxes,
  DarkRoom,
  Array,
  Array2,
  React
};